module.exports = {
  schema: {
    name: '貨品條碼',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '貨品條碼',
      },
      productKey: {
        type: 'String',
        name: '商品條碼',
      },
      serialNo: {
        type: 'String',
        name: '商品序號',
      },
      itemStatementKey: {
        type: 'String',
        name: '貨單品項編號',
      },
      cost: {
        type: 'Number',
        name: '計價',
      },
      salePrice: {
        type: 'Number',
        name: '售價',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 250 },
        { key: 'productKey', width: 200 },
        { key: 'serialNo', width: 100 },
        { key: 'itemStatementKey', width: 200 },
        { key: 'cost', width: 100 },
        { key: 'salePrice', width: 100 },
      ],
    },
    editor: {
      config: { titleSm: 2, titleMd: 1 },
      groups: [
        {
          name: '貨品條碼紀錄',
          rows: [
            [{ key: 'key', disabled: true }],
            [{ key: 'productKey', disabled: true }],
            [{ key: 'serialNo', disabled: true }],
            [{ key: 'itemStatementKey', disabled: true }],
            [{ key: 'cost', disabled: true }],
            [{ key: 'salePrice', disabled: true }],
          ],
        },
      ],
    },
  },
}




// WEBPACK FOOTER //
// ./src/models/itemBarcodes.js